/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    fork, call, select, takeLatest,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';

// TODO: Convert and use actions
import * as actions from './FuneralService-Actions';
import { retrieveCart } from '../../Cart/ducks/RetrieveCart/RetrieveCart-Operations';

import orderClient from '../../../../../../apis/checkout-apis/orderClient';
import cartServiceClient from '../../../../../../apis/cart-service-apis/cartServiceClient';
import { checkJWT } from '../../../../Member/ducks/Auth/Auth-Operations';

import { getAddressSource } from '../../../../App/App-Selectors';
import { getOrderId } from '../../../../Member/ducks/Common/Common-Selectors';
import { processFeatureErrors } from '../../../../Checkout/ducks/Common/ducks/Error/Error-Operations';

function* prepareRecipientCartSympathy({ viewStartTime, viewEndTime = '' }) {
    const addressSource = yield select(getAddressSource);

    if (viewStartTime && typeof viewStartTime === 'string') {
        return {
            sympathySource: addressSource === 'SCI' ? addressSource : 'OTHER',
            viewStartTime,
            viewEndTime,
        };
    }

    return null;
}

export async function getViewTimeForFuneral({
    cartId, cartItemId, promisedAvailableTime, zipCode, state, country, jwtToken,
}) {
    if (cartId && cartItemId) {
        try {
            let deliveryDate = null;
            const currentDate = promisedAvailableTime ? new Date(promisedAvailableTime) : null;

            if (currentDate) {
                const currentDay = (`0${currentDate.getDate()}`).slice(-2);
                const currentMonth = (`0${currentDate.getMonth() + 1}`).slice(-2);
                deliveryDate = currentDate ? `${currentDate.getFullYear()}-${currentMonth}-${currentDay}` : null;
            }
            const payload = {
                env: {},
                jwtToken,
                cartId,
                cartItemId,
                deliveryDate,
                zipCode,
                state,
                country,
            };

            const viewTimeResponse = await cartServiceClient.displayViewTime(payload);
            const { viewTime } = viewTimeResponse.data;

            return viewTime;
        } catch (ex) {
            mbpLogger.logError({
                module: 'FuneralService-Operations.js',
                function: 'getViewTimeForFuneral',
                jsError: ex,
            });
            return '';
        }
    }
    return '';
}

function* workerViewFuneralServiceTime(action) {
    try {
        const jwtToken = yield call(checkJWT);
        const cartId = yield select(getOrderId);
        const {
            cartItemId, promisedAvailableTime, zipCode, state, country,
        } = action.data;
        let deliveryDate = null;
        const currentDate = promisedAvailableTime ? new Date(promisedAvailableTime) : null;

        if (currentDate) {
            const currentDay = (`0${currentDate.getDate()}`).slice(-2);
            const currentMonth = (`0${currentDate.getMonth() + 1}`).slice(-2);
            deliveryDate = currentDate ? `${currentDate.getFullYear()}-${currentMonth}-${currentDay}` : null;
        }

        const payload = {
            env: {},
            jwtToken,
            cartId,
            cartItemId,
            deliveryDate,
            zipCode,
            state,
            country,
        };
        const viewTimeResponse = yield call(cartServiceClient.displayViewTime, payload);

        const { viewTime } = viewTimeResponse.data;
        return viewTime;

        // yield put(actions.updateRecipientForm({
        //     viewTime,
        // }));
    } catch (ex) {
        // yield put(actions.updateRecipientForm({
        //     viewTime: '',
        // }));
        mbpLogger.logError({
            module: 'FuneralService-Operations.js',
            function: 'workerViewFuneralServiceTime',
            jsError: ex,
        });
        return '';
    }
}

function* workerDeleteFuneralServiceTime(action) {
    const cartId = yield select(getOrderId);
    const { cartItemId } = action.data;
    try {
        const jwtToken = yield call(checkJWT);
        if (cartId && cartItemId) {
            const payload = {
                env: {},
                jwtToken,
                cartId,
                cartItemId,
            };

            yield call(cartServiceClient.deleteViewTime, payload);
            // yield put(actions.updateRecipientForm({ funeralServiceTime: '' }));
            yield call(retrieveCart);
        }
    } catch (ex) {
        mbpLogger.logError({
            module: 'FuneralService-Operations.js',
            function: 'workerDeleteFuneralServiceTime',
            jsError: ex,
        });

        yield fork(processFeatureErrors, {
            data: {
                orderItemId: action?.data?.cartItemId,
                errorFeatureType: 'cart',
                errorValues: ex.response?.data,
            },
        });
    }
}

function* workerUpdateFuneralServiceTime(action) {
    try {
        const {
            cartItemId, cartId, viewStartTime, viewEndTime,
        } = action.data;
        const sympathy = yield call(prepareRecipientCartSympathy, { viewStartTime, viewEndTime });
        const jwtToken = yield call(checkJWT);

        yield call(cartServiceClient.updateFuneralViewTime,
            {
                env: {},
                jwtToken,
                cartId,
                cartItemId,
                sympathy,
            });
        // Get Cart
        yield call(retrieveCart);
    } catch (ex) {
        yield fork(processFeatureErrors, {
            data: {
                orderItemId: action?.data?.cartId,
                errorFeatureType: 'cart',
                errorValues: ex.response?.data,
            },
        });

        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'FuneralService-Operations.js',
            function: 'workerUpdateFuneralServiceTime',
            jsError: ex,
        });
    }
}

function* watcherUpdateFuneralServiceTime() {
    yield takeLatest(actions.updateFuneralServiceTime().type, workerUpdateFuneralServiceTime);
}

function* watcherViewFuneralServiceTime() {
    yield takeLatest(actions.triggerGetViewTime().type, workerViewFuneralServiceTime);
}

function* watcherDeleteFuneralServiceTime() {
    yield takeLatest(actions.triggerDeleteViewTime().type, workerDeleteFuneralServiceTime);
}

/* PWA Desktop Code End */

const watchers = [
    fork(watcherUpdateFuneralServiceTime),
    fork(watcherViewFuneralServiceTime),
    fork(watcherDeleteFuneralServiceTime),
];

export { watchers };

export default {};
